import { Component, Input } from '@angular/core';
// Import como namespace: ver el mismo comentario en platform-health-api-indicators.component.ts.
// "maxOf" público de este componente y "maxOf" del helper se llamarían igual con un import nombrado;
// "metrics.maxOf(...)" no se confunde con "this.maxOf(...)".
import * as metrics from '../_helpers/platform-health-metrics';
import { DatabaseBlock, MetricSeries } from '../_types/platform-health';

/// Los dos indicadores de base de datos: se pintan igual en "Visión global" y en la pestaña "Base
/// de datos", así que viven en un único componente para no copiar la fila entre las dos plantillas.
@Component({
    selector: 'app-platform-health-database-indicators',
    templateUrl: './platform-health-database-indicators.component.html',
    styleUrls: ['./platform-health-database-indicators.component.scss'],
    standalone: false
})
export class PlatformHealthDatabaseIndicatorsComponent {
    @Input() public database: DatabaseBlock | null = null;

    public maxOf(series: MetricSeries[] | undefined, name: string): number | null {
        return metrics.maxOf(series, name);
    }

    public avgOf(series: MetricSeries[] | undefined, name: string): number | null {
        return metrics.avgOf(series, name);
    }
}
